import { useEffect, useState } from 'react'

import { fetchAssistantContextLabels, type AssistantContextLabels } from '@/lib/assistant-api'
import {
	buildAssistantPageContext,
	enrichPageContextWithLabels,
	formatPageContextLabel,
	type AssistantPageContext,
} from '@/lib/assistant-page-context'

export function useAssistantContextLabels(
	pathname: string,
	search: string | undefined,
	enabled = true
): AssistantContextLabels {
	const [labels, setLabels] = useState<AssistantContextLabels>({})

	useEffect(() => {
		if (!enabled) {
			setLabels({})
			return
		}

		const context = buildAssistantPageContext(pathname, undefined, search)
		if (!context.storeId && !context.productId && !context.siteId) {
			setLabels({})
			return
		}

		let cancelled = false
		void fetchAssistantContextLabels(context)
			.then((next) => {
				if (!cancelled) setLabels(next)
			})
			.catch(() => {
				if (!cancelled) setLabels({})
			})

		return () => {
			cancelled = true
		}
	}, [enabled, pathname, search])

	return labels
}

export function buildAssistantContextLabel(
	pathname: string,
	pageName: string | undefined,
	labels: AssistantContextLabels,
	search?: string
): string | null {
	return formatPageContextLabel(
		enrichPageContextWithLabels(buildAssistantPageContext(pathname, pageName, search), labels)
	)
}

export function buildCurrentPageContext(
	pathname: string,
	pageName: string | undefined,
	labels: AssistantContextLabels,
	search?: string
): AssistantPageContext {
	return enrichPageContextWithLabels(buildAssistantPageContext(pathname, pageName, search), labels)
}
